import React from 'react'
import { Grid } from '@material-ui/core'
import CardHit from 'modules/search/components/Widgets/CustomCardHit'
import { Hit } from 'modules/search/types'

type PropTypes = {
  hits: Hit[]
  indexContextValue?: {
    targetedIndex?: string
  }
}

const Hits = (props: PropTypes) => {
  const { hits }: { hits: Hit[] } = props
  return (
    <Grid container direction="row" spacing={3}>
      {hits.map((hit: Hit) => (
        <CardHit key={hit.objectID} hit={hit} index={props.indexContextValue} />
      ))}
    </Grid>
  )
}

const areEqual = (props: PropTypes, nextProps: PropTypes) => {
  return JSON.stringify(props) === JSON.stringify(nextProps)
}

export default React.memo(Hits, areEqual)
